import { render } from "./bfbbb.vue?vue&type=template&id=834f636c&scoped=true&ts=true"
import script from "./bfbbb.vue?vue&type=script&lang=ts"
export * from "./bfbbb.vue?vue&type=script&lang=ts"

import "./bfbbb.vue?vue&type=style&index=0&id=834f636c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834f636c"]])

export default __exports__